import * as React from 'react';

import { DeleteQuizUrl } from '../../../../api/quizApi';

const DeleteQuizUrlContext = React.createContext<DeleteQuizUrl>(undefined);

interface Props {
  deleteQuizUrl: DeleteQuizUrl;
  children: React.ReactNode;
}

export function DeleteQuizUrlContextProvider({
  deleteQuizUrl,
  children,
}: Props) {
  return (
    <DeleteQuizUrlContext.Provider value={deleteQuizUrl}>
      {children}
    </DeleteQuizUrlContext.Provider>
  );
}

export function useDeleteQuizUrl() {
  const value = React.useContext(DeleteQuizUrlContext);
  if (value === undefined) {
    throw new Error(
      'Delete Quiz Url is not defined. Make sure to use a DeleteQuizUrlContextProvider'
    );
  }
  return value;
}
